import React from "react";
import SubjectImage from "../../Components/SubjectImage/SubjectImage";
import {
  describeCriticalAlert,
  getToastPresentation,
} from "./toastPresentation";

function CriticalAlertDetails({ toast, userData, nameId, summaryId }) {
  const {
    colorStyle,
    priorityDescription,
    truncatedLocationType,
    showJmsOrBookingId,
    displayName,
    imageUrl,
    fallbackImageSrc,
  } = getToastPresentation(toast, userData);

  return (
    <>
      <p id={summaryId} hidden>
        {describeCriticalAlert(toast, userData)}
      </p>
      <div className="critical-toast-card-top-section">
        <SubjectImage
          imageUrl={imageUrl}
          fallbackSrc={fallbackImageSrc}
          className="critical-toast-card-profile-image"
          onError={(e) => {
            if (toast?.documentInfo?.imageUrl) {
              e.target.src = "/svgs/MonitoredSubjectCard/user-circle.svg";
              e.target.className = "critical-toast-card-profile-image";
            }
          }}
        />
      </div>
      <div className="critical-toast-information-section">
        <div id={nameId} className="critical-toast-information-name">
          {displayName}
        </div>
        <div className="critical-toast-information-jms-booking-id">
          {showJmsOrBookingId}
        </div>
        <div className="critical-toast-information-description-location-container">
          <div
            className="critical-toast-information-description"
            style={colorStyle}
          >
            {priorityDescription}
          </div>
          <div className="critical-toast-information-location-container">
            <div className="critical-toast-information-location-attribute">
              {`Location: `}
            </div>
            <div className="critical-toast-information-truncated-location">
              {` ${truncatedLocationType}`}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CriticalAlertDetails;
